import { combineReducers } from "redux";
import { reducer as oidcReducer } from "redux-oidc";
import BeneficiarioReducer from "./beneficiario_reducer";
import ExameReducer from "./exame_reducer";
import PrestadorReducer from "./prestador_reducer";
import biometryReducer from "./biometryReducer";

const rootReducer = combineReducers({
  biometrics: biometryReducer,
  oidc: oidcReducer,
  beneficiario: BeneficiarioReducer,
  exame: ExameReducer,
  prestador: PrestadorReducer,
});

export default rootReducer;

export * from "./beneficiario_reducer";
export * from "./exame_reducer";
export * from "./prestador_reducer";
export * from "./biometryReducer";
